import { usePostOfficeRoute } from '@atlassian/post-office-context/store';

/**
 * Returns a record of search params derived from the current Post Office route context,
 * enriched with the current browser pathname.
 *
 * The pathname is read on every render — and since `usePostOfficeRoute()` is reactive,
 * this hook will re-run on SPA navigation, ensuring the pathname stays up to date.
 */
export const usePostOfficeSearchParams = (): Record<string, string> => {
	const route = usePostOfficeRoute();

	let result: Record<string, string> = {};

	if (route?.searchParams) {
		result = Object.fromEntries(route.searchParams);
	}

	if (typeof window !== 'undefined' && typeof window.location?.pathname === 'string') {
		result = { ...result, pathname: window.location.pathname };
	}

	return result;
};
